import { render, staticRenderFns } from "./Editarfarmaco.vue?vue&type=template&id=7f9b93b6&scoped=true"
import script from "./Editarfarmaco.vue?vue&type=script&lang=js"
export * from "./Editarfarmaco.vue?vue&type=script&lang=js"
import style0 from "./Editarfarmaco.vue?vue&type=style&index=0&id=7f9b93b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9b93b6",
  null
  
)

export default component.exports